import React, { useEffect } from "react";
import { Card, CardBody, Row, Col, Button } from "reactstrap";
import "../../../assets/css/custom.css";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "components/Sidebar/Sidebar.js";
import TabChart from "./tabChart.js";
import TabLog from "../BoitierLog/tabLog.js";

export default function BoitierChart() {
  const nav = useNavigate();
  const params = useParams();

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      nav("/login");
    }
  }, [nav]);

  const previousPage = () => {
    nav("/showBoitier/" + params.id);
  };

  return (
    <>
      <div className="main-box">
        {/* <Sidebar /> */}
        <Row>
          <div className="content-wrapper-custom">
            <Button
              className="float-right"
              color="primary"
              onClick={previousPage}
              style={{ zIndex: "1" }}
            >
              Retour à la page précédente
            </Button>
            <Col lg="12">
              <Row className="CenterAll">
                <div className="containertitle">
                  <h2 className="titlePage">GRAPHIQUES</h2>
                </div>
              </Row>
              <Card>
                <CardBody>
                  <TabChart />
                </CardBody>
              </Card>
            </Col>
          </div>
          <div className="content-wrapper-custom">
            <Col lg="12">
              <Row className="CenterAll">
                <div className="containertitle">
                  <h2 className="titlePage">LOGS DES CAPTEURS</h2>
                </div>
              </Row>
              <Card>
                <CardBody>
                  <TabLog />
                </CardBody>
              </Card>
            </Col>
          </div>
        </Row>
      </div>
    </>
  );
}